import { Identifiable } from "app/shared/models/identifiable.model";
import { TypeDashboard } from "../enums/dashboard-type.enum";
import { WData } from "./data.model";

export interface Dashboard extends Identifiable {
  width: number;
  type: TypeDashboard;
  userId: string;
  widgets: Widget[];
  denomination: string;
}

export enum WidgetSubType {
  //ofs
  OF_ATTENTE_REINTEGRATION = "OF_ATTENTE_REINTEGRATION",
  OF_ATTENTE_PROD = "OF_ATTENTE_PROD",
  OF_EN_PROD = "OF_EN_PROD",
  OF_ATTENTE_VALIDATION = "OF_ATTENTE_VALIDATION",
  /** @deprecated Conservé pour rétrocompat config — l'état n'est plus utilisé. */
  OF_ATTENTE_BILAN_MATIERE = "OF_ATTENTE_BILAN_MATIERE",
  OF_ATTENTE_PLANIF = "OF_ATTENTE_PLANIF",
  //commandesClient
  COMMANDE_CLIENT_EN_COURS_DE_TRAITEMENT = "COMMANDE_CLIENT_EN_COURS_DE_TRAITEMENT",
  COMMANDE_CLIENT_EN_COURS_DE_PREPARATION = "COMMANDE_CLIENT_EN_COURS_DE_PREPARATION",
  COMMANDE_CLIENT_PRETE = "COMMANDE_CLIENT_PRETE",
  //commandesFournisseur
  COMMANDE_FOURNISSEUR_EN_ATTENTE_ENVOI = "COMMANDE_FOURNISSEUR_EN_ATTENTE_ENVOI",
  COMMANDE_FOURNISSEUR_EN_ATTENTE_CONFIRMATION = "COMMANDE_FOURNISSEUR_EN_ATTENTE_CONFIRMATION",
  COMMANDE_FOURNISSEUR_EN_ATTENTE_LIVRAISON = "COMMANDE_FOURNISSEUR_EN_ATTENTE_LIVRAISON",
  COMMANDE_FOURNISSEUR_LIVREE_PARTIELLEMENT = "COMMANDE_FOURNISSEUR_LIVREE_PARTIELLEMENT",
  //specif
  SPECIFICATION_REDIGEE = "SPECIFICATION_REDIGE",
  SPECIFICATION_VALIDEE = "SPECIFICATION_VALIDEE",
}

export interface Widget extends Identifiable {
  x: number;
  y: number;
  h: number;
  w: number;
  type: WidgetType;
  mobileIndex: number;
  subType?: WidgetSubType;
  color: number;
  squeeze?: boolean;
}

export interface WidgetData extends Identifiable {
  type: WidgetType;
  data: {
    type: WidgetType;
    data: WData;
  };
}

export enum WidgetType {
  PRODUCTIVITE_MOYENNE = "PRODUCTIVITE_MOYENNE",
  OF_EN_COURS = "OF_EN_COURS",
  HEURES_TRAVAILLES = "HEURES_TRAVAILLES",
  QUANTITE_OF = "QUANTITE_OF",
  CADENCE_REELLE = "CADENCE_REELLE",
  QUANTITE_PRODUITE_PERIODE = "QUANTITE_PRODUITE_PERIODE",
  LIVE_PRODUCTION = "LIVE_PRODUCTION",

  //OF GENERIC
  OF_LIST = "OF_LIST",
  //COMMANDE CLIENT GENERIC
  COMMANDE_CLIENT_LIST = "COMMANDE_CLIENT_LIST",
  //COUVERTURE DES COMMANDES (besoins vs stock)
  COUVERTURE_COMMANDES = "COUVERTURE_COMMANDES",
  //COMMANDE FOURNISSEUR GENERIC
  COMMANDE_FOURNISSEUR_LIST = "COMMANDE_FOURNISSEUR_LIST",
  //PLANNING TRANSVERSAL
  PLANNING = "PLANNING",
  //SPECIFICATION GENERIC
  SPECIFICATION_LIST = "SPECIFICATION_LIST",

  //financier
  CA_CUMULE = "CA_CUMULE",
  CA_PAR_PERIODE = "CA_PAR_PERIODE",
  CA_DELTA = "CA_DELTA",
  REPARTITION_PAR_CLIENT = "REPARTITION_PAR_CLIENT",
  CA_N_MOINS_1 = "CA_N_MOINS_1",

  //stocks
  LOT_PAR_ETAT = "LOT_PAR_ETAT",
  VALEUR_PAR_FAMILLE = "VALEUR_PAR_FAMILLE",
  EVOLUTION_VALEUR = "EVOLUTION_VALEUR",
  NB_LOT_DLC = "NB_LOT_DLC",

  //qualite (IFS / ISO 9001)
  NC_STATS = "NC_STATS",
  NC_CLOSURE_METRICS = "NC_CLOSURE_METRICS",
  NC_SUPPLIER_COMPLIANCE = "NC_SUPPLIER_COMPLIANCE",
  CERTIFICAT_BIO_ECHEANCE = "CERTIFICAT_BIO_ECHEANCE",

  //articles
  QUICK_WIN = "QUICK_WIN",
  CONSOS_PAR_ARTICLE = "CONSOS_PAR_ARTICLE", //OK
  PRODUCTIONS = "PRODUCTIONS",
  ACHATS = "ACHATS",
  ACHATS_EVOLUTION = "ACHATS_EVOLUTION",
  VENTES = "VENTES",
  MARGE = "MARGE",
  HEURES_OFS = "HEURES_OFS",
  CA_PERIODE_ARTICLE = "CA_ARTICLE",
  CA_CUMULE_ARTICLE = "CA_CUMULE_ARTICLE",
  MOUVEMENTS_ARTICLES = "MOUVEMENTS_ARTICLES",
  STOCKS_ARTICLE = "STOCKS_ARTICLE",

  //tiers
  ACHATS_EVOLUTION_TIERS = "ACHATS_EVOLUTION_TIERS",
  VENTE_EVOLUTION_TIERS = "VENTE_EVOLUTION_TIERS",
  CA_CUMULE_TIERS = "CA_CUMULE_TIERS",
  CA_PAR_PERIODE_TIERS = "CA_PAR_PERIODE_TIERS",
  MARGE_TIERS = "MARGE_TIERS",
  ACHATS_TIERS = "ACHATS_TIERS",
  VENTES_TIERS = "VENTES_TIERS",
  COMMANDES_TIERS = "COMMANDES_TIERS",
  COMMANDES_CLIENTS_TIERS = "COMMANDES_CLIENTS_TIERS",

  //ligne
  QUANTITE_PRODUITE_LIGNE = "QUANTITE_PRODUITE_LIGNE",
  MAIN_OEUVRE_LIGNE = "MAIN_OEUVRE_LIGNE",
  PRODUCTIVITE_LIGNE = "PRODUCTIVITE_LIGNE",
  COUTS_LIGNE = "COUTS_LIGNE",
  OFS_LIGNE = "OFS_LIGNE",
  ARTICLES_PRODUITS_LIGNE = "ARTICLES_PRODUITS_LIGNE",

  //user_infos (opérateur)
  HEURES_USER_INFOS = "HEURES_USER_INFOS",
  REPARTITION_TRAVAIL_USER_INFOS = "REPARTITION_TRAVAIL_USER_INFOS",
  OFS_USER_INFOS = "OFS_USER_INFOS",
  PRODUCTIVITE_USER_INFOS = "PRODUCTIVITE_USER_INFOS",
  LIGNES_USER_INFOS = "LIGNES_USER_INFOS",
  ARTICLES_PRODUITS_USER_INFOS = "ARTICLES_PRODUITS_USER_INFOS",
}
